export default {
  namespaced: true,
  state: {
    videos: [
      {
        id: 1,
        grade: 10,
        field: [3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد خسرو محمدزاده',
        course: 'درس ریاضی انسانی',
        image: 'https://store4.classino.com/filepond/product/pe-10.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/nyfe1qq/vt/frame',
      },
      {
        id: 2,
        grade: 9,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد آرمین کمالی',
        course: 'درس فیزیک',
        image: 'https://store4.classino.com/filepond/product/p-9.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/wyqb238/vt/frame',
      },
      {
        id: 3,
        grade: 12,
        field: 12,
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد امید مصلایی',
        course: 'درس شیمی',
        image: 'https://store4.classino.com/filepond/product/p-10.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/pvu51id/vt/frame',
      },
      {
        id: 4,
        grade: 9,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد پارمیس محمودی',
        course: 'درس علوم',
        image: 'https://store4.classino.com/filepond/product/p-9.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/myly1c5/vt/frame',
      },
      {
        id: 5,
        grade: 12,
        field: 12,
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد خسرو محمدزاده',
        course: 'درس ریاضی',
        image: 'https://store4.classino.com/filepond/product/pe-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/cfo02g9/vt/frame',
      },
      {
        id: 6,
        grade: 11,
        field: [1,2],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد کامبیز فرزانه',
        course: 'درس شیمی',
        image: 'https://store4.classino.com/filepond/product/p-11.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/pxa388w/vt/frame',
      },
      {
        id: 7,
        grade: 11,
        field: [3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد خسرو محمدزاده',
        course: 'درس ریاضی انسانی',
        image: 'https://store4.classino.com/filepond/product/pe-11.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/kqw2q0z/vt/frame',
      },
      {
        id: 8,
        grade: 11,
        field: [1],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد امید سلمانی',
        course: 'درس ریاضی تجربی و حسابان',
        image: 'https://store4.classino.com/filepond/product/p-11.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/pqngdbq/vt/frame',
      },
      {
        id: 9,
        grade: 12,
        field: [3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد مصطفی رضایی مهر',
        course: 'درس جغرافیا',
        image: 'https://store4.classino.com/filepond/product/pe-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/xndjtdb/vt/framee',
      },
      {
        id: 10,
        grade: 9,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد عمار تاجبخش',
        course: 'درس عربی',
        image: 'https://store4.classino.com/filepond/product/p-9.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/pbn1u93/vt/frame',
      },
      {
        id: 11,
        grade: 9,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد بهرام جلالی',
        course: 'درس ریاضی',
        image: 'https://store4.classino.com/filepond/product/p-9.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/dsj9kkp/vt/frame',
      },
      {
        id: 12,
        grade: 10,
        field: [1,2],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد آرمین کمالی',
        course: 'درس فیزیک',
        image: 'https://store4.classino.com/filepond/product/p-10.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/mim10el/vt/frame',
      },
      {
        id: 13,
        grade: 7,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد محمدرضا اعتباری',
        course: 'درس علوم',
        image: 'https://store4.classino.com/filepond/product/p-7.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/cpi2pk1/vt/frame',
      },
      {
        id: 14,
        grade: 12,
        field: [1,2,3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد فراز توکلی',
        course: 'درس ادبیات',
        image: 'https://store4.classino.com/filepond/product/p-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/vzpyy37/vt/frame',
      },
      {
        id: 15,
        grade: 10,
        field: [1,2,3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد وهاب اصغری',
        course: 'درس عربی',
        image: 'https://store4.classino.com/filepond/product/p-10.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/qhbiz87/vt/frame',
      },
      {
        id: 16,
        grade: 12,
        field: 12,
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد مصطفی رضایی مهر',
        course: 'درس تاریخ',
        image: 'https://store4.classino.com/filepond/product/pe-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/xqegp7b/vt/frame',
      },
      {
        id: 17,
        grade: 11,
        field: [1,2],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد مهدی براتی',
        course: 'درس فیزیک',
        image: 'https://store4.classino.com/filepond/product/p-11.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/quk6o6q/vt/frame',
      },
      {
        id: 18,
        grade: 10,
        field: [1,2],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد مهدی براتی',
        course: 'درس فیزیک',
        image: 'https://store4.classino.com/filepond/product/p-10.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/tzg1hx6/vt/frame',
      },
      {
        id: 19,
        grade: 12,
        field: [1,2,3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد محمد واعظی',
        course: 'درس عربی',
        image: 'https://store4.classino.com/filepond/product/p-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/pqa4609/vt/frame',
      },
      {
        id: 20,
        grade: 6,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد محمد مهدی سلحشور',
        course: 'درس علوم',
        image: 'https://store4.classino.com/filepond/product/p-6.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/tbmb5x1/vt/frame',
      },
      {
        id: 21,
        grade: 12,
        field: [3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد حمید اثباتی',
        course: 'درس جامعه شناسی',
        image: 'https://store4.classino.com/filepond/product/pe-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/gji74m6/vt/frame',
      },
      {
        id: 22,
        grade: 9,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد علی فروغی نیا',
        course: 'درس هوش و استعداد تحلیلی',
        image: 'https://store4.classino.com/filepond/product/p-9.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/iqb9ncd/vt/frame',
      },
      {
        id: 23,
        grade: 7,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد سارا احمدی',
        course: 'درس زبان',
        image: 'https://store4.classino.com/filepond/product/p-7.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/uftazgc/vt/frame',
      },
      {
        id: 24,
        grade: 8,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد سارا احمدی',
        course: 'درس زبان',
        image: 'https://store4.classino.com/filepond/product/p-8.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/soms6h5/vt/frame',
      },
      {
        id: 25,
        grade: 9,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد سارا احمدی',
        course: 'درس زبان',
        image: 'https://store4.classino.com/filepond/product/p-9.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/ypwe0ko/vt/frame',
      },
      {
        id: 26,
        grade: 12,
        field: [2],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد محمد صحت کار',
        course: 'درس گسسته',
        image: '',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/zuhxm7h/vt/frame',
      },
      {
        id: 27,
        grade: 11,
        field: [2],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد محمد صحت کار',
        course: 'درس هندسه',
        image: 'https://store4.classino.com/filepond/product/pt-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/hum5w5i/vt/frame',
      },
      {
        id: 28,
        grade: 12,
        field: [3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد علی فروغی نیا',
        course: 'درس فلسفه و منطق',
        image: 'https://store4.classino.com/filepond/product/pe-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/cpj8ifv/vt/frame',
      },
      {
        id: 29,
        grade: 9,
        field: '',
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد روزبه فکری',
        course: 'درس پیام آسمانی',
        image: 'https://store4.classino.com/filepond/product/p-9.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/zzukukq/vt/frame',
      },
      {
        id: 30,
        grade: 11,
        field: [1],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد آریا بام رفیع',
        course: 'درس زیست',
        image: 'https://store4.classino.com/filepond/product/pt-11.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/cdi2476/vt/frame',
      },
      {
        id: 31,
        grade: 10,
        field: [1,2,3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد روزبه فکری',
        course: 'درس دین و زندگی',
        image: 'https://store4.classino.com/filepond/product/p-10.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/wouw237/vt/frame',
      },
      {
        id: 32,
        grade: 11,
        field: [1,2,3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد روزبه فکری',
        course: 'درس دین و زندگی ',
        image: 'https://store4.classino.com/filepond/product/p-11.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/rpqcex8/vt/frame',
      },
      {
        id: 33,
        grade: 12,
        field: [1,2,3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد عمار تاجبخش',
        course: 'درس عربی',
        image: 'https://store4.classino.com/filepond/product/p-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/dvjowam/vt/frame',
      },
      {
        id: 34,
        grade: 12,
        field: [1,2,3],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد محمد مهدی شاهرودی ',
        course: 'درس عربی',
        image: 'https://store4.classino.com/filepond/product/p-12.jpg',
        video_link: 'https://www.aparat.com/video/video/embed/videohash/wkcw009/vt/frame',
      },

      {
        id: 35,
        grade: 11,
        field: [1,2],
        title: 'حل سوال امتحان نهایی',
        teacher: 'استاد احسان غیاثی   ',
        course: 'درس ریاضی تجربی و حسابان',
        image: 'https://store4.classino.com/filepond/product/p-11.jpg',
        video_link: '',
      },
    ],
    drawer: false,
    grade:  null,
    field:    null,
    grades: [
      {
        title: "دوازدهم",
        value: 12,
        hasField: true,
      },
      {
        title: "یازدهم",
        value: 11,
        hasField: true,
      },
      {
        title: "دهم",
        value: 10,
        hasField: true,
      },
      {
        title: "نهم",
        value: 9,
        hasField: false,
      },
      {
        title: "هشتم",
        value: 8,
        hasField: false,
      },
      {
        title: "هفتم",
        value: 7,
        hasField: false,
      },
      {
        title: "ششم",
        value: 6,
        hasField: false,
      },
      {
        title: "پنجم",
        value: 5,
        hasField: false,
      },
      {
        title: "چهارم",
        value: 4,
        hasField: false,
      },
      {
        title: "سوم",
        value: 3,
        hasField: false,
      },
      {
        title: "دوم",
        value: 2,
        hasField: false,
      },
      {
        title: "اول",
        value: 1,
        hasField: false,
      },
    ],
    fields: [
      {
        title: "تجربی",
        value: 1
      },
      {
        title: "ریاضی",
        value: 2
      },
      {
        title: "انسانی",
        value: 3
      },
      {
        title: "هنر",
        value: 4
      },
      {
        title: "سایر",
        value: 0
      },
    ],
    selectedVideo: null,
  },
  getters: {
    videos(state) {
      if(state.grade?.value){
        if(state.field?.value){
          return state.videos.filter(video => video.grade === state.grade.value && video.field === state.field.value);
        }else {
          return state.videos.filter(video => video.grade === state.grade.value);
        }
      }else {
        return [];
      }
    },
    grade(state) {
      return state.grade
    },
    field(state) {
      return state.field
    },
    selectedVideo(state) {
      return state.selectedVideo
    }
  },
  mutations:{
    CHANGE_SELECTED_VIDEO_STATE(state, val){
      state.selectedVideo = val
    },
    CHANGE_GRADE_STATE(state, val){
      state.grade = val;
      state.field = null;
    },
    CHANGE_FIELD_STATE(state, val){
      state.field = val
    },
  },
  actions:{
    selectVideo(context){
      context.commit('CHANGE_SELECTED_VIDEO_STATE', true)
    },
  },
}
